import React from 'react';
import { DisableTelOnTabletDesktop } from '@rmstransactions/components';
import { snswContactTelephoneNumber } from 'consts/links';

const TelephoneContactNumber: React.FC = () => (
  <DisableTelOnTabletDesktop phoneNumber={snswContactTelephoneNumber} />
);

export default TelephoneContactNumber;
